import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100vw - 550px) !important',
    maxWidth: '1310px',
    [theme.breakpoints.down('md')]: {
      width: '90% !important'
    }
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.5rem',
    fontSize: theme.size.sm
  },

  table: {
    '& .table': {
      [theme.breakpoints.up(960)]: {
        width: '100vw !important'
      },

      [theme.breakpoints.up(1300)]: {
        width: '100% !important'
      },
      '& .table-row': {
        height: '36px !important'
      }
    }
  },

  addTask: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1rem',
    cursor: 'pointer',
    color: '#323436',
    fontSize: theme.size.sm,

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '0.5rem',
      fontSize: theme.size.base,
      color: theme.palette.primary.main
    }
  }
}))

export default useStyles
